import React from 'react';
import loadable from '@loadable/component';

const RRuleLib = loadable.lib(() => import(/* webpackPrefetch: true */ 'rrule'));

export function withRRuleData(WrappedComponent) {
  return props => <RRuleLib>{({ RRule }) => <WrappedComponent RRule={RRule} {...props} />}</RRuleLib>;
}
